<h1 mat-dialog-title>Select organizations by tags  @if (res && res.total) {
  <small> ({{ res?.total }} organizations)</small>
}</h1>

<div mat-dialog-content>

  <div class="flex-row gap-16">
    <div class="flex-1">
      @if (isTagsLoading) {
        <label class="label">
          Tags <mat-progress-spinner color="primary" mode="indeterminate" diameter="30"></mat-progress-spinner>
        </label>
      }
      @if (!isTagsLoading) {
        <app-multi-tags #multiTags [readOnly]="false" [placeholder]="'Tags - format [tag:value]'" [labels]="tags"></app-multi-tags>
      }
    </div>
    <div class="actions">
      <lib-button variant="raised" icon="search" (buttonClick)="onSearch()">Search</lib-button>
    </div>
  </div>


  <div class="table">

    @if (isLoading) {
      <mat-progress-spinner mode="indeterminate" color="primary" [diameter]="40"></mat-progress-spinner>
    }

    <table [class.grid-loading]="isLoading" mat-table [dataSource]="organizations" [hidden]="isLoading" style="width: 100%;">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Description </th>
        <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['name', 'description']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['name', 'description'];"></tr>
    </table>
  </div>
</div>

<div mat-dialog-actions class="gap-8">
  <lib-button variant="stroked" mat-dialog-close>Cancel</lib-button>
  <lib-button variant="raised" (buttonClick)="onSelect()">Select Tags</lib-button>
</div>